import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../components/ui/table';
import { ExportExcel } from '../components/ui/ExportExcel';

const staticData = [
  { id: 1, moduleName: 'Sales Basics', executedBy: 'John Doe', date: '2024-05-01', status: 'Completed' },
  { id: 2, moduleName: 'Product Training', executedBy: 'Jane Smith', date: '2024-05-03', status: 'In Progress' },
  { id: 3, moduleName: 'Compliance', executedBy: 'Alice Brown', date: '2024-05-05', status: 'Not Started' },
];

export default function ModuleExecutionReport() {
  return (
    <div className="container mx-auto p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Module Execution Report</CardTitle>
          <ExportExcel
            data={staticData}
            columns={[
              { label: 'Module Name', key: 'moduleName' },
              { label: 'Executed By', key: 'executedBy' },
              { label: 'Date', key: 'date' },
              { label: 'Status', key: 'status' },
            ]}
            filename="module-execution-report.xlsx"
          />
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Module Name</TableHead>
                <TableHead>Executed By</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {staticData.map(row => (
                <TableRow key={row.id}>
                  <TableCell>{row.moduleName}</TableCell>
                  <TableCell>{row.executedBy}</TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
} 